const PIXEL_ID = '2420809105336403';
type MetaPixel = ((...args: unknown[]) => void) & {
  queue: unknown[][];
  callMethod?: (...args: unknown[]) => void;
  push?: MetaPixel;
  loaded: boolean;
  version: string;
};
let loaded = false;
let loadedPath: string | undefined;
export const metaPixelLoaded = () => loaded;
export const metaPixelNeedsNavigation = () => loaded && window.location.pathname !== loadedPath;

/** Only approved public documents; navigation unloads the SDK before private content. */
export function loadMetaPixel() {
  if (loaded || !['/', '/pricing'].includes(window.location.pathname)) return;
  const target = window as Window & { fbq?: MetaPixel; _fbq?: MetaPixel };
  if (target.fbq) return;
  const fbq: MetaPixel = Object.assign((...args: unknown[]) => {
    if (fbq.callMethod) fbq.callMethod(...args); else fbq.queue.push(args);
  }, { queue: [] as unknown[][], loaded: true, version: '2.0' });
  fbq.push = fbq;
  target.fbq = fbq;
  if (!target._fbq) target._fbq = fbq;
  fbq('init', PIXEL_ID);
  fbq('track', 'PageView');
  if (window.location.pathname === '/pricing') {
    fbq('track', 'ViewContent', { content_name: 'Rill pricing', content_category: 'pricing' });
  }
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  loadedPath = window.location.pathname;
  loaded = true;
  document.head.appendChild(script);
}
